import React from 'react';

import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';
import { BaseConfirmationModal } from 'src/modals/common';

export type VerifierCredentialStatusNoticeModalArgs = {
  onSubmit: () => void;
};

export const VerifierCredentialStatusNoticeModal: React.FC = () => {
  const { args, closeModal, isOpen } = useModal<VerifierCredentialStatusNoticeModalArgs>(
    ModalId.VerifierCredentialStatusNoticeModal,
  );

  const {
    onSubmit = () => {
      return null;
    },
  } = args ?? {};

  const onCloseModal = React.useCallback(() => {
    closeModal(ModalId.VerifierCredentialStatusNoticeModal);
  }, [closeModal]);

  const onSubmitModal = React.useCallback(async () => {
    await onSubmit();
    onCloseModal();
  }, [onCloseModal, onSubmit]);

  const contentText =
    'Your company has not been approved to create verification requests yet. Any changes made to your company information can influence the credentialing process.';

  return (
    <BaseConfirmationModal
      isOpen={isOpen}
      onSubmit={onSubmitModal}
      onClose={onCloseModal}
      maxWidth={477}
      title="Are you sure?"
      contentText={contentText}
      buttonText="Yes, sure"
      actionButtonColor="error"
    />
  );
};
